import { createSlice } from "@reduxjs/toolkit";

const SLICE_NAME = "messagingChannel";

export const messagingChannelSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        connectionErrorMessage: "",
        subRecordingStatusPayload: null,
        subArchiveStatusPayload: null,
        subSessionStatusPayload: null,
        subDownloadTrimPayload: null,
        subExportCSVPayload: null,
        channelHubUrl:null,
        token: null
    },
    reducers: {
        startConnecting(state,action) {
            return { ...state,channelHubUrl:action.payload.url,token:action.payload.token };
        },
        connectionError(state, action) {
            return { ...state, connectionErrorMessage: action.payload };
        },

        subscribeRecordingStatus(state, action) {
            return { ...state, subRecordingStatusPayload: action.payload };
        },
        unsubscribeRecordingStatus(state) {
            return { ...state, subRecordingStatusPayload: null };
        },
        subscribeArchiveStatus(state, action) {
            return { ...state, subArchiveStatusPayload: action.payload };
        },
        unsubscribeArchiveStatus(state) {
            return { ...state, subArchiveStatusPayload: null };
        },

        subscribeSessionStatus(state, action){
            return { ...state, subSessionStatusPayload: action.payload }
        },
        unsubscribeSessionStatus(state) {
            return { ...state, subSessionStatusPayload: null };
        },

        subscribeDownloadTrimStatus(state, action){
            return { ...state, subDownloadTrimPayload: action.payload }
        },
        unsubscribeDownloadTrimStatus(state) {
            return { ...state, subDownloadTrimPayload: null };
        },
        subscribeExportCSVStatus(state, action){
            return { ...state, subExportCSVPayload: action.payload }
        },
        unsubscribeExportCSVStatus(state) {
            return { ...state, subExportCSVPayload: null };
        }
    }
});

export const messagingChannelActions = messagingChannelSlice.actions;

export default messagingChannelSlice.reducer;


